<template>
	<v-data-table 
		:items="items"
		:headers="headers"
		:page.sync="mOptions.page"
		:items-per-page.sync="mOptions.itemsPerPage"
		:sort-by.sync="mOptions.sortBy"
		:sort-desc.sync="mOptions.sortDesc"
		:loading="loading"
		:server-items-length="serverItemsLength"
		:item-key="itemUniqueKey"
		:footer-props="{ itemsPerPageOptions: [10,25,50,100] }"
		:mobile-breakpoint="0"
		class="elevation-0 hub-pages-data-table"
		:class="computedClass"
		@click:row="editPage"
	>
		<template #item.dateCreated="{ item }">
			<span class="nowrap">{{ formatDate(item.dateCreated) }}</span>
		</template>
		<template #item._actions="{ item }">
			<span class="nowrap">
				<v-tooltip left>
					<template #activator="{ on, attrs }">
						<v-btn v-bind="attrs" v-on="on" text small color="#0083EB" :disabled="loading" @click.stop="viewAuditLog(item)">
							<v-icon small>icon-q-list</v-icon>
						</v-btn>
					</template>
					<span>View Audit Log</span>
				</v-tooltip>
				<v-btn text small color="#0083EB" :disabled="loading" @click.stop="copyPage(item)">
					<v-icon small>fas fa-copy</v-icon>
				</v-btn>
				<v-btn text small color="#0083EB" :disabled="loading" @click.stop="editPage(item)">
					<v-icon small>fas fa-pencil-alt</v-icon>
				</v-btn>
				<v-btn text small color="#0083EB" :disabled="loading" @click.stop="viewPage(item)">
					<v-icon small>fas fa-eye</v-icon>
				</v-btn>
				<v-btn text small class="red--text" :disabled="loading" @click.stop="deletePage(item)">
					<v-icon v-if="item.status !== 'Trash'" small>fas fa-trash-alt</v-icon>
					<v-icon v-else small>fas fa-minus-circle</v-icon>
				</v-btn>
			</span>
		</template>
	</v-data-table>
</template>

<script>
import { defaultOptions } from '../config/index'

const headers = [{
		text: 'Title',
		value: 'title',
	},
	{
		text: 'Slug',
		value: 'slug',
	},
	{
		text: 'Date Created',
		value: 'dateCreated',
	},
	{
		text: 'Division',
		value: 'division',
	},
	{
		text: 'Last Change By',
		value: 'lastChangeBy',
		sortable: false,
	},
	{
		text: 'Status',
		value: 'status',
	},
	{
		text: '',
		value: '_actions',
		sortable: false,
		class: 'table-actions',
		width: 220,
	},
]

export default {
    props: {
		items: { type: Array, default: () => [] },
		options: { type: Object, default: () => ({ ...defaultOptions }) },
		serverItemsLength: { type: Number, default: -1 },
		loading: { type: Boolean, default: false },
	},
    data () {
        return {
			headers,
			itemUniqueKey: 'id',
        }
    },
    computed: {
		mOptions: {
			get () { return this.options },
			set (v) { this.$emit('update-options', v) },
		},
		isMobileView () {
			return this.$vuetify.breakpoint.xs
		},
		computedClass () {
			return [
				this.isMobileView && 'hub-pages-data-table--mobile'
			]
		},
    },
    methods: {
		viewAuditLog (page) {
			if (this.loading) { return }
			this.$emit('view-audit', page)
		},
		copyPage (page) {
			if (this.loading) { return }
			this.$emit('copy-page', page)
		},
		editPage (page) {
			if (this.loading) { return }
			this.$emit('edit-page', page)
		},
		viewPage (page) {
			if (this.loading) { return }
			this.$emit('view-page', page)
		},
		deletePage (page) {
			if (this.loading) { return }
			this.$emit('delete-page', page)
		},
    },
}
</script>

<style lang="scss" scoped>
@import '../style/style.scss';

.hub-pages-data-table {
	&.hub-pages-data-table--mobile {
		::v-deep {	
			.v-data-footer {
				.v-data-footer__select {
					margin-right: 2rem;
					font-size: 0;

					.v-select {
						margin-left: 0;
					}
				}

				.v-data-footer__pagination {
					margin: 0 2rem 0 0;
				}

				.v-btn {
					margin: 0;
				}
			}
		}
	}

	::v-deep {
		thead tr th {
			line-height: 1.2;
			height: 36px;
		}
	}
}
</style>
